import { NgModule, ModuleWithProviders, Optional, SkipSelf, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { BlockUIModule } from 'ng-block-ui';

import { ConfigProvider, LoaderService } from './services';
import { GlobalErrorHandler } from './handlers';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    NgbModule,
    ToastrModule.forRoot(),
    BlockUIModule.forRoot()
  ],
  declarations: [],
  exports: [CommonModule, NgbModule, BlockUIModule, ToastrModule]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      console.log('Core module is already loaded');
      throw new Error('Core module is already loaded');
    }
  }
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [ConfigProvider, LoaderService,
        { provide: APP_INITIALIZER, useFactory: appConfigServiceFactory, deps: [ConfigProvider], multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandler }
      ]
    };
  }
}

export function appConfigServiceFactory(config: ConfigProvider): any {
  return () => config.load();
}

export { ConfigProvider, LoaderService } from './services';
export { BaseConstants } from './constants';
export { GlobalErrorHandler } from './handlers';
